import React, { Component, Fragment } from 'react'
import pt from 'prop-types'
import { connect } from 'react-redux'

class RoutesContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      closingLast: false,
      children: null
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.mods.list.length > 0 && nextProps.mods.list.length === 0) {
      this.setState({ closingLast: true, children: this.props.children })
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.mods.list.length === 0 && this.props.children !== nextProps.children
  }

  componentDidUpdate() {
    const { scrollPosition, list } = this.props.mods
    if (list.length === 0 && this.state.closingLast) {
      // window.scrollTo(0, scrollPosition)
      if (window.scrollY === scrollPosition) {
        this.setState({ closingLast: false })
      }
    }
  }
  render() {
    const { children: stateChildren } = this.state
    const { children } = this.props

    return <Fragment>{stateChildren === children ? stateChildren : children}</Fragment>
  }
}

RoutesContainer.propTypes = {
  children: pt.node,
  mods: pt.shape({
    list: pt.array,
    startLocation: pt.string,
    scrollPosition: pt.number
  })
}

export default connect(
  ({ user, modals, mods, feed, layout, location, scroll }) => ({ user, modals, mods, feed, layout, location, scroll }),
  {}
)(RoutesContainer)
